<div class="forecast-admin-management">
    <div class="row">
        <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
            <div class="d-flex">
                <mat-tab-group (selectedTabChange)="tabChangeClick($event)">
                    <mat-tab *ngFor="let tab of tabs" [label]="tab.label"> </mat-tab>
                </mat-tab-group>
            </div>
        </div>
        <div *ngIf="selectedTab == 'forecast_master'">
            <app-forecast-master-table></app-forecast-master-table>
        </div>
        <div *ngIf="selectedTab == 'forecast_service_management'">
            <app-forecast-service-managment-table></app-forecast-service-managment-table>     
        </div>
        <div *ngIf="selectedTab == 'forecast_role_management'">
            <app-forecast-role-management [segmentData]="segmentData" [isForecastAdmin]="isForecastAdmin"></app-forecast-role-management>
        </div>
        <div *ngIf="selectedTab == 'forecast_multi_matrix'">
            <app-forecast-multi-matrix [isForecastAdmin]="isForecastAdmin"></app-forecast-multi-matrix>
        </div>
        <div *ngIf="selectedTab == 'projections_workflow'">
            <div class="m-2 p-3 align-items-center forecast-workflow-tab"> 
                <label class="tabl-header table-data-font"  style="font-size: larger !important;">Projections Workflow</label>
                <div class="row uitk-c-card uhc-font">
                    <div class="mt-3 mb-3 d-flex align-items-center"> 
                        <!-- receipients mails -->
                        <div class="col-md-5 col-sm-5 col-lg-5 col-xl-4 col-xs-6 mb-3 recipients-input">
                            <label class="tabl-header table-data-font">Recipients</label>
                            <mat-form-field appearance="outline">
                                <textarea matInput type="text" cols="100" [(ngModel)]="forecastTriggerRecipients" rows="3"
                                    [maxlength]="500" class="trigger-textarea"></textarea>
                            </mat-form-field>
                            <div
                                class="help-block uitk-c-input__message--error" style="background-color:green;">
                                <span>
                                    Please note that ';' is the delimiter for multiple email addresses
                                </span>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 mb-3  d-flex align-items-center">
                            <button class="m-1 uitk-c-button uitk-c-button--default me-3 mat-mdc-raised-button techops-global-button uitk-u-margin-right--base 
                                uitk-u-margin-bottom--xs" mat-raised-button color="primary" (click)="triggerWorkflow()">
                                Trigger Projections Workflow
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>